const cancel = 'Anuluj'
const save = 'Zapisz'

export default {

  global: {
    generalError: 'To pech! Żądanie nie mogło zostać przetworzone. Proszę odświeżyć tę stronę.',
    signature: 'Łączymy pozdrowienia,',
  },

  component: {
    actionBar: {
      actions: 'Actions',
      hideActions: 'Hide actions',
      next: 'Next',
      previous: 'Previous',
    },

    addButton: {
      add: 'Add',
    },

    aiSummaryBox: {
      transcript: 'Transcript',
      summary: 'Summary',
    },

    attachments: {
      add: 'Dodaj CV i inne wymagane załączniki',
      placeholderWithDescription: 'Dodaj wymagane załączniki',
      remove: 'Usuń',
      allowedFileTypes: 'Dozwolone typy plików',
      errors: {
        size: 'Plik jest za duży, maksymalny rozmiar to 5MB.',
        empty: 'Plik nie zawiera danych',
        invalidType: fileType => `Wgrywanie plików ${fileType} nie jest dozwolone ze względów bezpieczeństwa`,
        typeNotWhitelisted: 'Niestety, ten typ pliku jest niedozwolony.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Politykę prywatności',
      termsLinkText: 'Regulamin',
      privacyPolicyText: 'Dbamy o Twoją prywatność. Przeczytaj naszą ',
      termsText1: 'Przeczytaj i zaakceptuj ',
      termsText2: 'zanim przekażesz nam swoje dane osobowe.',
      privacyLink: 'https://get.recright.com/privacy-policy',
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Jeśli nie życzysz sobie przetwarzania swoich danych osobowych, możesz wysłać nam prośbę o usunięcie ich na adres ${mail}.`,
      customSupportPrivacyInfo: link => `Jeżeli nie chcesz, abyśmy przetwarzali Twoje dane osobowe, możesz poprosić o ich usunięcie, korzystając z łącza ${link}.`,
    },

    buttons: {
      close: 'Zamknij',
    },

    competencies: {
      addCompetency: 'Add a new competency',
      edit: 'Edit competencies',
      done: 'Done',
      defaultsDescription: 'If you are unsure what competencies to use, we have defined some good defaults to start with.',
      getDefaults: 'Get default competencies',
    },

    competency: {
      warning: 'Remove competency and all its ratings?',
    },

    confirmDelete: {
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },

    confirm: {
      cancel: 'Usuń podejście',
      confirm: 'Spróbuj ponownie',
    },

    confirmButton: {
      wait: count => `Poczekaj ${count}`,
      confirm: 'Potwierdź',
    },

    controlStatus: {
      text: {
        empty: 'Wypełnij',
        valid: () => 'Gotowe',
      },
      textarea: {
        empty: 'Wypełnij',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Ustaw',
        valid: () => 'Gotowe',
      },
      file: {
        empty: 'Wybierz',
        valid: () => 'Zmień',
      },
      list: {
        empty: 'Dodaj',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Szukaj',
        valid: () => 'Gotowe',
      },
    },

    cookieConsentModal: {
      title: 'Nasza witryna korzysta z plików cookie',
      body: 'Akceptując wszystkie pliki cookie, zgadzasz się na przechowywanie ich na swoim urządzeniu w celu usprawnienia nawigacji w witrynie, analizy sposobu korzystania z witryny i w celu pomocy w naszych działaniach marketingowych.',
      learnMoreLinkText:
        'Dowiedz się więcej, w jaki sposób używamy plików cookie',
      learnMoreLink: 'https://get.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Zarządzaj plikami cookie',
      acceptAll: 'Akceptuj wszystkie pliki cookie',
      manageTitle: 'Akceptuj wszystkie pliki cookie',
      necessaryCookiesTitle: 'Niezbędne pliki cookie',
      necessaryCookiesBody:
        'Te pliki cookie są niezbędne dla działania witryny. Nie można ich wyłączyć w naszych systemach.',
      performanceCookiesTitle: 'Wydajnościowe pliki cookie',
      performanceCookiesBody:
        'Te pliki cookie pozwalają nam zliczać wizyty i źródła ruchu, dzięki czemu możemy mierzyć i poprawiać wydajność naszej witryny.',
      confirmChoices: 'Potwierdź mój wybór',
      marketingCookiesTitle: 'Marketingowe pliki cookie',
      marketingCookiesBody:
        'Te pliki cookie pozwalają nam personalizować reklamy i mierzyć ich skuteczność.',
      functionalCookiesTitle: 'Pliki cookie związane z funkcjonalnością',
      functionalCookiesBody:
        'Te pliki cookie są wykorzystywane w celu zwiększenia funkcjonalności strony internetowej. Bez tych plików cookie niektóre funkcjonalności mogą stać się niedostępne. Pliki cookie związane z funkcjonalnością dotyczą np. usług czatu internetowego lub preferencji użytkownika.',
    },

    emailAddresses: {
      candidateNamePlaceholder: 'Candidate name',
      remove: 'Usuń',
      importCsv: 'Import CSV',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Email bounced back. Make sure the recipient received your message.',
      },
      Permanent: {
        General: 'Email delivery failed. Recipients email provider rejected the message.',
        NoEmail: 'Email address does not exist.',
        Suppressed: 'Email was not delivered due to previous unsuccessful delivery attempts.',
      },
      Transient: {
        General: 'Email bounced back. Make sure the recipient received your message.',
        MailboxFull: 'Recipient inbox is full.',
        MessageTooLarge: 'The message content is too large.',
        ContentRejected: 'The message content rejected.',
        AttachmentRejected: 'The attachment rejected.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'The number given is already attatched to a candidate in the interview.',
    },

    error403: {
      heading: 'Zabronione',
      content: 'Nasz serwer kulturalnie (lecz stanowczo) odmówił wykonania prośby Twojej przeglądarki. Ważne, aby usługę Recright używać tylko na jednym urządzeniu/jednej przeglądarce w tym samym czasie.',
      link: 'Strona główna',
    },

    error404: {
      heading: 'Nic nie znaleziono',
      content: 'Szukaliśmy usilnie, ale nie ma strony internetowej o adresie, jaki podano. Być może skorzystano z nieaktualnego linku lub niechcący wprowadzono zły adres.',
      link: 'Strona główna',
    },

    error410: {
      heading: 'Zamknięte',
      content: 'Oferta pracy nie może zostać wyświetlona, ponieważ rekrutacja została zakończona lub skończył się okres aplikacji.',
      link: 'Strona główna',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: 'Inicjalizacja...',
      connection_error_hint: 'Nie można było nawiązać połączenia sieciowego.\nSpróbuj odświeżyć stronę.',
      permission_hint: 'Musisz pozwolić tej stronie korzystać z kamery internetowej i mikrofonu.',
      searching_camera_hint: 'Szukanie kamery internetowej...',
      camera_reserved_hint: 'Inna aplikacja lub strona internetowa korzysta z Twojej kamery internetowej.\nZamknij tę aplikację i odśwież stronę.',
      camera_reserved_hint_chrome_extra: '\n\nSzanowny Użytkowniku przeglądarki Chrome, musisz udzielić zezwolenia na korzystanie przez Recright z kamery internetowej w oknie poniżej paska adresu.',
      no_camera_hint: 'Kamera internetowa nie została odnaleziona.',
      no_mic_hint: 'Mikrofon nie został odnaleziony.',
      uploading_text: 'Wysyłanie...',
      rtmpt_in_use: 'Ten etap nie byłby konieczny,\ngdyby Twój administrator sieciowy zezwolił na RMTP. Zapytaj nas, co trzeba zrobić.',
      preview_text: 'Kamera internetowa jest w trybie podglądu.',
      close_text: 'Zamknij kamerę',
      remove_text: 'Usuń podejście',
      noflash_errortext_install: link => `Wygląda na to, że nie masz wtyczki Adobe Flash Player. Musi być ona zainstalowana, żeby móc nagrywać filmy. Pobierz Flash z tego miejsca: ${link}`,
      noflash_errortext_enable: link => `Jeśli Flash jest już zainstalowany, a wciąż otrzymujesz ten komunikat. Sprawdź ten link: ${link}`,
      noflash_errortext_differentbrowser: 'Możesz również spróbować użyć innej przeglądarki, która obsługuje nagrywanie poprzez HTML5. Sugerujemy przeglądarkę Chrome lub Firefox.',
    },

    footer: {
      terms: 'Warunki',
      license: 'General Terms of Service',
      privacyPolicy: 'Polityka prywatności',
      customSupport: link => `Kontakt: ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Jak oceniasz wrażenia z rozmowy?',
      howWouldYouRateJobAd: 'Jak oceniasz swoje wrażenia związane z aplikacją?',
      yourResponseIsAnonymous: 'Twoja odpowiedź jest anonimowa.',
      thankYouFeedback: 'Dziękujemy za Twoją opinię!',
    },

    candidateFooter: {
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://get.recright.com/privacy-policy',
      accessibilityReportLink: 'https://websitemedia.recright.com/wp-content/uploads/2024/11/06112306/accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Niestety, ten typ pliku jest niedozwolony.',
      isRequired: 'To pole jest obowiązkowe.',
      isEmail: value => `${value} nie jest prawidłowym adresem e-mail.`,
      isDate: value => `${value} nie jest prawidłowym formatem daty.`,
      invalidUrl: 'URL jest nieprawidłowy.',
      singleHireEndError: 'Pojedyncza rekrutacja nie może trwać dłużej niż 60 dni.',
      isNotTooOldForLive: 'Podana data jest z przeszłości.',
      isNotAfterEndDate: 'The date is after the date the job ad closes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Phone number has already been added.',
      duplicateCompetency: 'Competency with that name already exists',
      isNotDuplicateTemplateName: 'Template with that name already exists',
    },

    jobAdApplication: {
      name: 'Nazwa',
      city: 'Miejscowość',
      email: 'E-mail',
      phone: 'Numer telefonu',
      applyForPosition: 'Aplikuj na stanowisko',
      back: 'Wstecz',
      continue: 'Kontynuuj',
      submit: 'Złóż',
      saveForLater: 'Kontynuuj później',
      namePlaceholder: 'Podaj imię i nazwisko',
      emailPlaceholder: 'Podaj adres e-mail',
      phonePlaceholder: 'Podaj numer telefonu',
      cityPlaceholder: 'Podaj miejscowość, w której mieszkasz',
      links: 'Dodaj linki, na przykład do profilu na LinkedIn',
      legendBasicInfo: 'Dane podstawowe',
      legendLinks: 'Linki',
      legendAttachments: 'Załączniki',
      legendAdditionalFields: 'Dane dodatkowe',
      coverLetter: 'List motywacyjny',
      attachments: 'Załączniki',
      introduction: 'Napisz krótki opis swojej osoby',
      thankYou: 'Dziękujemy.',
      luck: 'Powodzenia!',
      close: 'Zamknij',
      required: 'Pola zaznaczone symbolem * są obowiązkowe.',
    },

    jobAdContainer: {
      endTime: date => (date ? `aktualne do ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Aplikuj na stanowisko',
    },

    jobAdQuickInterview: {
      title: 'Szybka rozmowa wideo',
      back: 'Wstecz',
      submit: 'Złóż',
      saveForLater: 'Kontynuuj później',
      description: 'Aby poznać Cię szybciej, chcieliśmy prosić o udzielenie krótkiej odpowiedzi na nasze szybkie pytanie rekrutacyjne. Wyraź swoją osobowość i nadaj aplikacji wyjątkowego charakteru.',
      requiredNote: 'Pamiętaj, że jest to część procesu kwalifikacyjnego, a rekruter otrzyma Twoją aplikację dopiero po tym, gdy nagrasz swoją odpowiedź.',
      reminderNote: 'Możesz nagrać odpowiedź od razu albo dokończyć rozmowę później - po otrzymaniu przypomnienia w e-mailu.',
    },

    jobAdRow: {
      responses: 'Aplikacje',
      status: {
        open: 'Otwórz',
        filled: 'Wypełnione',
        cancelled: 'Anulowane',
        done: 'Gotowe',
        close: 'Zamknij',
        draft: 'Zamknięte (robocze)',
        hidden: 'Ukryte',
      },
    },

    interviewRow: {
      responses: 'Kandydaci',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Wyświetl profil na LinkedIn',
    },

    linkedInButton: {
      error: 'Błąd pobierania informacji profilowych. Spróbuj ponownie.',
      buttonText: 'Złóż podanie przez LinkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Wypełnij wstępnie formularz przy użyciu informacji z profilu na LinkedIn',
      linkedInOr: 'Lub',
      error: 'Błąd pobierania informacji profilowych. Spróbuj ponownie.',
    },

    linkListInput: {
      addField: 'Dodaj',
      removeField: 'Usuń',
      invalidUrl: 'URL jest nieprawidłowy.',
    },

    liveRoom: {
      greeting: name => `Hello, ${name}.`,
      notYetStarted: startTime =>
        `The interview has not yet started. The interview starts at ${startTime}.`,
      interviewTitle: title => `Interview title: ${title}`,
      interviewStartsIn: timeLeft => `The Interview starts in: ${timeLeft}`,
      interviewHasEnded: 'The interview has ended.',
      youHaveLeft: 'You have left the interview.',
      rejoinInterview: 'Rejoin interview',
      joinInterview: 'Join interview',
      goToEvaluations: 'Continue to evaluation',
      structuredInterview: {
        timeEstimateText: timeEstimate => `${timeEstimate} minutes`,
        guideNotesPlaceHolder: stepTitle => `Notes for ${stepTitle}`,
        goToNextStepButtonText: 'Go to next section',
        totalTime: 'Total time in interview:',
        timeIn: partName => `Time in ${partName}:`,
        nextStep: stepTitle => `Next up: ${stepTitle}`,
      },
    },

    loadingButton: {
      loading: 'Wczytywanie...',
      saving: 'Zapisywanie...',
      sending: 'Wysyłanie...',
    },

    modalApplicationForm: {
      applyForPosition: 'Aplikuj na stanowisko',
      continue: 'Kontynuuj',
      name: 'Podaj imię i nazwisko',
      email: 'Podaj adres e-mail',
      phoneNumber: 'Podaj numer telefonu',
      links: 'Możesz podać linki',
      legendLinks: 'Linki',
      legendAttachments: 'Załączniki',
      coverLetter: 'List motywacyjny',
      attachments: 'Załączniki',
      introduction: 'Napisz opis swojej osoby',
      thankYou: 'Dziękujemy.',
      luck: 'Powodzenia!',
      close: 'Zamknij',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Ogólnie dostępny link',
      info: 'Jest to adres publiczny oferty pracy, który możesz udostępnić.\nKtokolwiek zainteresowany stanowiskiem będzie mógł\nzapoznać się z ofertą i aplikować.\nOtrzymasz standardowe powiadomienie, kiedy aplikacje zaczną spływać.\n\nOto publiczny link do oferty pracy:',
    },

    modalVideoAdd: {
      title: 'Dodaj nowy film',
      chooseTitle: 'Dodaj nowy film',
      titlePlaceholder: 'Wpisz tutaj tytuł filmu',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Wyślij nowy film',
      info: 'Maksymalny rozmiar pliku filmowego to 500 MB. Zalecamy, aby filmy zostały skompresowane przed ich przesłaniem, dzięki temu czas przesyłania i konwersji znacznie się skróci.',
    },

    modalCandidateInfo: [
      {
        headline: 'Nagraj swoją odpowiedź filmową  ',
        content: 'tyle razy, ile sobie życzysz. Filmy zostaną zapisane niezwłocznie po rejestracji i możesz powrócić do rozmowy wideo poprzez link, który wysłaliśmy Ci na adres e-mail.',
        mobileContent: 'tyle razy, ile sobie życzysz. Dodaj film do rozmowy. Zobaczysz, jak film jest przesyłany i zapisany w rozmowie. Do rozmowy wideo można powrócić poprzez link, który wysłaliśmy Ci na adres e-mail. <br><br><strong>Jeśli na Twoim ekranie z filmem nic nie widać, a używasz urządzenia mobilnego firmy Apple, rozwiązanie problemu znajdziesz <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">w tym miejscu</a>.</strong>',
      },
      {
        headline: 'Po nagraniu ',
        content: 'upewnij się, że film odtwarza się prawidłowo i słychać Twój głos. Po naciśnięciu przycisku „Wyślij” Twoja odpowiedź zostanie zablokowana i nie będzie jej można edytować.',
      },
      {
        headline: 'Po zakończeniu rozmowy ',
        content: 'wciśnij przycisk „Wyślij odpowiedzi i zakończ rozmowę”. Po tej czynności nie można wrócić do rozmowy wideo. Jeśli chcesz zamknąć stronę, ale kontynuować rozmowę w późniejszym terminie, wciśnij przycisk „Kontynuuj później”.',
      },
      {
        headline: 'Jeśli potrzebujesz pomocy ',
        content: mailto => `przy którejś z odpowiedzi podczas rozmowy, kliknij przycisk „Pomoc” w prawym dolnym rogu strony lub wyślij e-mail na adres ${mailto}.`,
        customContent: link => `Kontakt: ${link}`,
      },
    ],

    navigationBar: {
      back: 'Wstecz',
      dashboard: 'Pulpit',
      frontpage: 'Strona główna',
    },

    personDetails: {
      stage: 'Stage',
      namePlaceholder: 'Candidate',
      contact: 'Contact',
      links: 'Links',
      attachments: 'Attachments',
      coverLetter: 'Cover Letter',
      referrer: 'Origin',
      referrerInfo: 'The website from which the candidate came to the service.',
      noStage: 'Not in any stage yet',
      lastSeen: time => `Last seen ${time}.`,
      headerAdditionalInformation: 'Additional information',
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      notVisited: 'Hasn\'t yet visited the interview.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Also found on ${count} other positions`,
    },

    phoneInput: {
      placeholder: example => `Nr telefonu w formacie ${example}`,
    },

    questionsAndResponses: {
      response: 'Response',
      noResponse: 'No response',
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
      aiInsights: 'AI Insights',
      showQuestion: 'Show question video',
      hideQuestion: 'Hide question video',
      question: 'Question',
      nonAnswerableInfo: 'Question is non-answerable.',
      evaluationCriteriaLabel: 'Evaluation criteria',
    },

    rating: {
      ownVote: 'Your rating',
      yourVotePlaceholder: 'You have not voted yet.',
      totalVotes: count => `Total ${count} ratings`,
      noRatings: 'No ratings yet',
      mobileModalHeader: 'Add your rating',
      yourRatingReset: 'Reset your vote',
      averageRating: 'Średnia ocena',
      reset: 'resetuj',
    },

    share: {
      share: 'Udostępnij',
      copy: 'Skopiuj link',
    },

    sort: {
      sort: 'Sortuj',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Wybrane',
      change: 'Zmień',
    },

    video: {
      videoNotFound: 'Film jest właśnie przetwarzany albo nie został znaleziony',
      retry: 'Spróbuj ponownie',
      originalLanguageLabel: 'Oryginał',
      englishLanguageLabel: 'Angielski',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Wyślij lub nagraj nowy film' : 'Wybierz plik'),
      videoPlaceholder: 'Nagraj swoją odpowiedź',
      uploadPlaceholderCandidate: 'Wyślij film',
      submit: 'Prześlij swoją odpowiedź',
      notAnswered: 'Nie udzielono odpowiedzi',
      remove: 'Usuń podejście',
      converting: 'Film jest konwertowany. Proszę czekać...',
      uploading: 'Film jest przesyłany. Proszę czekać...',
      error: {
        invalid: 'Wybrany plik jest za duży. Wybierz inny plik.',
        upload: 'Przykro nam, nie mogliśmy przesłać filmu. Spróbuj jeszcze raz.',
        transcode: 'Wybrany plik filmowy był uszkodzony lub nieprawidłowy. Spróbuj ponownie.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Pokaż więcej',
      showLessButtonText: 'Pokaż mniej',
      infoText1:
        'Podczas nagrywania pozostaw zakładkę aktywną na pierwszym planie. Podczas nagrywania nie korzystaj z żadnej innej aplikacji.',
      infoText2:
        'Filmy video w tle działają najlepiej w najnowszych przeglądarkach i na stosunkowo nowych i wydajnych urządzeniach.',
      infoText3:
        'Upewnij się, że inne aplikacje nie używają Twojego mikrofonu lub kamery.',
    },

    videoResponse: {
      videoPlaceholder: 'Nagraj swoją odpowiedź',
      uploadPlaceholder: 'Wyślij film',
      submit: 'Prześlij swoją odpowiedź',
      notAnswered: 'Nie udzielono odpowiedzi',
      required: 'To pytanie wymaga odpowiedzi',
      startInterview: 'Rozpocznij rozmowę',
    },

    webcam: {
      useVideoBgButtonText: 'Użyj tła wideo',
      removeVideoBgButtonText: 'Usuń tło wideo',
      starting: 'Rozpoczynam...',
      close: 'Zamknij kamerę',
      remove: 'Usuń podejście',
      record: 'Nagraj',
      stop: 'Zatrzymaj',
      retake: 'Kolejne podejście',
      submit: 'Prześlij swoją odpowiedź',
      converting: 'Film jest konwertowany. Proszę czekać...',
      uploading: 'Film jest przesyłany. Proszę czekać...',
      downloading: 'Film jest pobierany. Proszę czekać...',
      processing: 'Przetwarzanie...',
      uploadInProgress: 'Przesyłanie filmu w toku, nie zamykaj okna przeglądarki ani nie zmieniaj strony.',
      uploaded: 'Film przesłany.',
      error: {
        DevicesNotFoundError: 'Nie można użyć kamery lub mikrofonu. Sprawdź, czy są zainstalowane.',
        NotFoundError: 'Nie można użyć kamery lub mikrofonu. Sprawdź, czy są zainstalowane.',
        NotAllowedError: 'Nie masz uprawnień do używania kamery lub mikrofonu.',
        PermissionDismissedError: 'Udzielenie uprawnień zostało odrzucone. Udziel uprawnień do używania kamery lub mikrofonu.',
        PermissionDeniedError: 'Odmówiono udzielenia dostępu do kamery lub mikrofonu.',
        NotReadableError: 'Nie można odbierać sygnału z kamery lub mikrofonu. Możliwy problem sprzętowy.',
        SecurityError: 'Nie można użyć kamery lub mikrofonu z powodu błędu bezpieczeństwa',
        stream: 'Wystąpił błąd. Uruchom ponownie swoją przeglądarkę. Jeśli problem powtarza się, spróbuj użyć innej przeglądarki.',
        download: 'Pobieranie filmu nieudane. Chcesz spróbować ponownie?',
        upload: 'Wysłanie filmu nieudane. Chcesz spróbować ponownie?',
        emptyBlob: 'Pamięć Twojej przeglądarki lub urządzenia jest zapełniona, dlatego nie można utworzyć nagrania. Odśwież stronę, a jeśli to nie pomaga, zrestartuj przeglądarkę.  Jeśli problem powtarza się, spróbuj użyć innej przeglądarki.',
        alternativeRecorder: 'Możesz również przesłać plik, klikając na to.',
        reconnecting: 'Połączenie zostało przerwane. Próbuję połączyć się ponownie.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `Witaj! Chcemy zaprosić Cię na wideorozmowę ${title}! To zaproszenie zostało również wysłane na Twój adres e-mail. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
